import 'cookieconsent';
import { TrackJS } from 'trackjs';
import { loadJS } from '../helpers';

var JS_VERSION = '20250620.1';

TrackJS.install({
  token: 'dfd198aad7ec42d0925e17fb9497e083',
  version: JS_VERSION,
  onError: function (_, error) {
    // Ignore font awesome loading errors
    if (error.message.toLowerCase().includes('awesome')) {
      return false;
    }
    return true;
  },
});

TrackJS.addMetadata('application', 'landing');

var main = document.getElementById('epc-main');
var bundle = main.dataset.bundle;
var location = 'built';

var FEATURES = [
  typeof Object.assign === 'function',
  typeof document.body.classList !== 'undefined',
  typeof Element.prototype.closest === 'function',
];

if (bundle) {
  if (FEATURES.indexOf(false) > -1) {
    location = 'outdated';
  }
  var url = '/js/' + location + '/' + bundle + '.js?v=' + JS_VERSION;

  loadJS(url, function () {
    if (typeof window.initEPCPage === 'function') {
      window.initEPCPage();
    }
  });
}
initCookieConsent();

function initCookieConsent() {
  if ('cookieconsent' in window && typeof window.cookieconsent.initialise === 'function') {
    window.cookieconsent.initialise({
      palette: {
        popup: {
          background: '#edeff5',
          text: '#838391',
        },
        button: {
          background: '#4b81e8',
        },
      },
      theme: 'edgeless',
      content: {
        link: 'Learn more',
        href: 'https://europetro.com/privacy-policy',
      },
    });
  } else {
    console.error('Cannot initialise CookieConsent');
  }
}
